import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import searchVersions from './search-versions';

/**
 * Gets the ECAPPS for a specific org
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to get the list
 * @param {string} params.orgId - the ID or the org that you want to get the apps for
 * @param {Array<{appId: string; versionId?: string}>} params.apps - the list of apps to get the details for
 * @param {'card'|'details'} params.mode - the mode to get the app details in
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'apps', 'orgId'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    apps: { allowedTypes: ['array'] },
    mode: { allowedTypes: ['string'] },
  };

  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }

  const versions = await searchVersions(params);

  return (
    versions?.map((version) => ({
      ...version,
      // ID of the acquired version
      appVersionId: version.id,
      id: version.appId,
      isRetractedApp: Boolean(
        version.unpublishedDate && new Date(version.unpublishedDate) > new Date(version.publishedDate)
      ),
      distribution: version.isPrivate ? 'private' : 'public',
    })) ?? []
  );
};
